import React, { memo } from "react";

import { testIds } from "../../../../../core/testIds";
import { NavScrollArrow, NavArrowIcon, NavArrowSvg } from "./NavArrowsStyles";

interface NavSingleArrowProps {
    navScrollArrows: {
        isHovered: boolean;
        showLeftArrow: boolean;
        showRightArrow: boolean;
    };
    direction: 'left' | 'right';
    showTournamentCup: boolean;
    onClick: () => void;
}

const NavArrow: React.FC<NavSingleArrowProps> = ({
    navScrollArrows,
    showTournamentCup,
    direction,
    onClick
}) => {
    function isLeftArrow(dir: 'left' | 'right') {
        return dir === 'left';
    }

    return (
        <NavScrollArrow
            $direction={direction}
            $show={isLeftArrow(direction) ? navScrollArrows.showLeftArrow : navScrollArrows.showRightArrow}
            $hasTournaments={showTournamentCup}
            onClick={onClick}
            data-testid={testIds.navigation.scrollArrow(direction)}
        >
            <NavArrowIcon $direction={direction}>
                <NavArrowSvg
                    $direction={direction}
                    viewBox="0 0 24 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.6.6,12,8.8,20.4.6a2.18,2.18,0,0,1,3,0,2,2,0,0,1,0,2.8L12.6,14.6a1.76,1.76,0,0,1-1.2.6,1.76,1.76,0,0,1-1.2-.6L.6,3.4a2,2,0,0,1,0-2.8A2.18,2.18,0,0,1,3.6.6Z"
                        fill="currentColor"
                    />
                </NavArrowSvg>
            </NavArrowIcon>
        </NavScrollArrow>
    );
}

export default memo(NavArrow);